module.exports = __webpack_public_path__ + "static/image-video-thumbnail-79c0d4a35e375f916a46d4834829d45a.png";